import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Modal,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import axios from "axios";
import { getToken, base_url } from "../../config/config";

const FinalCalculationsProcessor = () => {
  const [data, setData] = useState([]);
  const [spalte1Values, setSpalte1Values] = useState([]);
  const [isANRDataFetched, setIsANRDataFetched] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalData, setModalData] = useState([]);
  const [selectedANR, setSelectedANR] = useState(null);

  // Fetch ANR values from the main API
  useEffect(() => {
    const fetchANRValues = async () => {
      try {
        const response = await axios.get(`${base_url}/v1/getBulkreport`);
        const anrData = response.data.data.map((item) => ({
          ANR: item.ANR,
          invoiceNo: item.invoiceNo,
          einzelpreis: item.Einzelpreis,
          costByUser: item.costByUser,
          profitOrLoss: item.profitOrLoss,
          totalHours: item.totalHours,
          users: item.users,
        }));
        setSpalte1Values(anrData);
        setIsANRDataFetched(true); // Enable the button
      } catch (error) {
        console.error("Error fetching ANR values:", error);
      }
    };

    fetchANRValues();
  }, []);

  // Function to fetch IDs and data from the final report API
  const fetchFinalReportData = async () => {
    try {
      const response = await axios.get(`${base_url}/v1/getFinalreport`);
      return response.data; // Assuming this returns the final report data with IDs
    } catch (error) {
      console.error("Error fetching final report data:", error);
      return [];
    }
  };

  // Function to fetch data and update FinalCalculations
  const fetchData = async () => {
    setIsFetching(true); // Disable the button
    try {
      const finalReportData = await fetchFinalReportData(); // Fetch IDs from final report
      const response = await axios.post(
        "http://35.159.43.224:3080/m1/data/details",
        {
          spalte1Values: spalte1Values.map((item) => item.ANR),
        },
      );

      // Prepare data for updating FinalCalculations
      const updatedData = await Promise.all(
        response.data.map(async (item) => {
          const matchingANR = spalte1Values.find(
            (sp) => sp.ANR === item.spalte1,
          );
          const totalAz = matchingANR
            ? parseFloat(matchingANR.totalHours) || 0
            : 0;

          // Get the corresponding ID from final report data
          const finalCalculation = finalReportData.find(
            (report) => report.excelBulkId.ANR === item.spalte1,
          );

          if (finalCalculation) {
            await updateFinalCalculations(finalCalculation._id, totalAz); // Pass the ID and totalAz
          } else {
            console.warn(
              `No matching FinalCalculation found for ANR: ${item.spalte1}`,
            );
          }

          return {
            ...item,
            totalAz, // Add totalAz to item for display
          };
        }),
      );

      setData(updatedData); // Store updated data
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsFetching(false); // Re-enable the button
    }
  };

  // Function to update FinalCalculations with totalAz
  const updateFinalCalculations = async (id, totalAz) => {
    try {
      const payload = { Modified_TotalTime: totalAz };
      await axios.put(`${base_url}/v1/updateFinalCalculation/${id}`, payload);
    } catch (error) {
      console.error(`Error updating FinalCalculation with ID ${id}:`, error);
    }
  };

  const handleRowClick = (anr) => {
    const detailedData = data.filter((row) => row.spalte1 === anr);
    setModalData(detailedData);
    setSelectedANR(anr);
    setModalOpen(true);
  };

  const handleClose = () => setModalOpen(false);

  return (
    <div>
      {isANRDataFetched && (
        <Button
          variant='contained'
          color='primary'
          onClick={fetchData}
          disabled={isFetching} // Disable the button while fetching
        >
          {isFetching ? "Abrufen..." : "Datensätze abrufen"}
        </Button>
      )}

      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>ANR</TableCell>
              <TableCell>Total AZ</TableCell>
              <TableCell>Invoice No</TableCell>
              <TableCell>Einzelpreis</TableCell>
              <TableCell>Cost By User</TableCell>
              <TableCell>Profit Or Loss</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, index) => (
              <TableRow key={index} onClick={() => handleRowClick(row.spalte1)}>
                <TableCell>{row.spalte1}</TableCell>
                <TableCell>{row.totalAz}</TableCell>
                <TableCell>{row.invoiceNo}</TableCell>
                <TableCell>{row.einzelpreis}</TableCell>
                <TableCell>{row.costByUser}</TableCell>
                <TableCell>{row.profitOrLoss}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      <Modal
        open={modalOpen}
        onClose={handleClose}
        aria-labelledby='modal-title'
        aria-describedby='modal-description'>
        <Box
          sx={{
            p: 2,
            backgroundColor: "white",
            margin: "auto",
            marginTop: "10%",
            maxWidth: 800,
          }}>
          <Typography id='modal-title' variant='h6' component='h2'>
            Details for ANR: {selectedANR}
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>User</TableCell>
                  <TableCell>Total Time</TableCell>
                  <TableCell>Description</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {modalData[0]?.users.map((user, index) => (
                  <TableRow key={index}>
                    <TableCell>{user.user}</TableCell>
                    <TableCell>{user.totalTime}</TableCell>
                    <TableCell>{user.description}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Modal>
    </div>
  );
};

export default FinalCalculationsProcessor;
